// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cw-4";
export var closeButton = "_cw-6";
export var dismissButton = "_cw-3";
export var editImageWithAiContainer = "_cw-8";
export var imageUploadWrapper = "_cw-7";
export var misspelledWord = "_cw-5";
export var spellCheckContainer = "_cw-2";
export var spin = "_cw-1";
export var spinning = "_cw-0";